import ActionBarContent from './ActionBarContent';
import ActionBarContentV2 from './ActionBarContent.actionbar_phase_1';
import withFeatureBranch from '../../../redux/flags/withFeatureBranch';
export default withFeatureBranch({ actionbar_phase_1: ActionBarContentV2 })(ActionBarContent);
//# sourceMappingURL=index.js.map